import type { ColoredMaterialResult } from "@color-finder/color-finder-api/models";
import axios from "axios";
import { type RequestState, useRequest } from "./request";

export function useDemoMaterials(): RequestState<ColoredMaterialResult> {
  return useRequest<ColoredMaterialResult>("/v0/demo-materials", axios);
}
